// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page-header-overdue-invoice[data-v-0a42607a] {\n  padding-top: 1rem;\n}", "",{"version":3,"sources":["webpack://assets/pages/overdue-invoice/index.vue","webpack://index.vue"],"names":[],"mappings":"AACA;EACE,iBAAA;ACAF","sourcesContent":["\n.page-header-overdue-invoice {\n  padding-top: 1rem;\n}\n",".page-header-overdue-invoice {\n  padding-top: 1rem;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
